export enum SignOutFailureType {
  // 存在余额和额度
  HAS_BALANCE = 714,
  HAS_CREDIT = 715,
  // 子账号存在余额和额度
  HAS_BALANCE_SUB = 735,
  HAS_CREDIT_SUB = 736,
  // 余额负数，额度为0
  HAS_BALANCE_NEGATIVE = 713,
  // 子账号余额负数，额度为0
  HAS_BALANCE_NEGATIVE_SUB = 734,
  // 作业未完成
  HAS_JOB_UNSTOP = 612,
  // 子账号作业未完成
  HAS_JOB_UNSTOP_SUB = 631,
}
